import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchPermissionModule = createAsyncThunk("fetchPermissionModule", async () => {
	const response = await axiosHttp.get(`permission/list/admin`);
	return response.data.data;
});

//action to assign permissions
export const assignPermissions = createAsyncThunk("assignPermissions", async (body) => {
	const response = await axiosHttp.post(`permission/create`, body);
	return response.data.data;
});

const permissionListSlice = createSlice({
	name: "permissionList",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		assign: null,
	},

	reducers: {
		resetStatePermissionList: (state) => {
			state.isLoading = false;
			state.error = null;
			state.data = null;
			state.assign = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(fetchPermissionModule.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchPermissionModule.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchPermissionModule.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});

		builder.addCase(assignPermissions.pending, (state, action) => {
			state.isLoading = true;
		});
		builder.addCase(assignPermissions.fulfilled, (state, action) => {
			state.isLoading = false;
			state.assign = action.payload;
		});
		builder.addCase(assignPermissions.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export const { resetStatePermissionList } = permissionListSlice.actions;
export default permissionListSlice.reducer;
